<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template v-if="!isBloggerView" slot="left">
      <!-- <el-button-group>
        <el-button size="medium" @click="setFilterStatus('全部')" :type="filteringStatus=='全部' ? 'primary' : ''">全部</el-button>
        <el-button size="medium" @click="setFilterStatus('已付款')" :type="filteringStatus=='已付款' ? 'primary' : ''">已付款</el-button>
        <el-button size="medium" @click="setFilterStatus('未付款')" :type="filteringStatus=='未付款' ? 'primary' : ''">未付款</el-button>
        <el-button size="medium" @click="setFilterStatus('交易完成')" :type="filteringStatus=='交易完成' ? 'primary' : ''">交易完成</el-button>
      </el-button-group> -->

      <el-select v-model="filteringStatus" @change="setFilterStatus" style="width: 120px">
        <el-option value="全部"></el-option>
        <el-option value="已付款"></el-option>
        <el-option value="未付款"></el-option>
        <el-option value="交易完成"></el-option>
      </el-select>

      <el-date-picker
        size="medium"
        v-model="filteringDateRange"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="開始日期"
        end-placeholder="結束日期"
        @input="onDateRangeChanged">
      </el-date-picker>

      <el-input size="medium" @keyup.enter.native="search" @input="delaySearch" style="width: 170px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button size="medium" @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

      <el-select size="medium" v-show="isShowTeamBuyingOrder" v-model="filteringTeamBuyingID" @change="search" placeholder="請選擇團購" filterable clearable style="width: 140px;margin-left: 10px;">
        <el-option v-for="obj in $store.state.teamBuying.list.filter(o => o.IsActive)" :key="obj.ID"
          :value="obj.ID"
          :label="obj.Tw.Title"/>
      </el-select>

    </template>
    <template v-if="!isBloggerView" slot="right">
      <el-button size="medium" @click="onExportExcel" style="margin-right: 20px;">匯出</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="訂單號碼" width="130px">
          <template slot-scope="scope">
            <a v-if="!isBloggerView" class="order-id" href="javascript:;" @click="$router.push({ name: 'order-detail', params: { id: scope.row.ID }, query: routeQuery})">{{scope.row | getOrderID}}</a>
            <span v-else>{{scope.row | getOrderID}}</span>
          </template>
        </el-table-column>
        <el-table-column label="訂單日期" width="110px">
          <template slot-scope="scope">
            {{scope.row.CreatedAt | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column label="訂單狀態" width="80px">
          <template slot-scope="scope">
            <span :class="`order-status ${scope.row.OrderStatus}`">{{scope.row.OrderStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款狀態" width="110px">
          <template slot-scope="scope">
            <span :class="`payment-status ${scope.row.PaymentStatus}`">{{scope.row.PaymentStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="送貨狀態" width="80px">
          <template slot-scope="scope">
            <span :class="`logistics-status ${scope.row.LogisticsStatus}`">{{scope.row.LogisticsStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="訂購人">
          <template slot-scope="scope">
            <span v-if="isBloggerView">
              {{scope.row.BuyerDisplay}}
            </span>
            <span v-else-if="scope.row.BuyerInfo">
              <span v-show="!scope.row.User">[未註冊]</span>
              {{scope.row.BuyerInfo && (scope.row.BuyerInfo.Name)}} -
              {{scope.row.BuyerInfo && scope.row.BuyerInfo.Email}}
            </span>
            <span v-else-if="scope.row.User">
              {{scope.row.User && (scope.row.User.Profile.Name)}} -
              {{scope.row.User && scope.row.User.Profile && (scope.row.User.Profile.Email)}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="合計" width="110px">
          <template slot-scope="scope">
            NT${{scope.row.PaidAmount|amountFormat}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="onUpdate(scope.row)">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import { getOrderID } from '@/utils/filters/formatter.js'
// excel
import ExcelGenerator from '../excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: '全部',
      filteringDateRange: null,
      filteringTeamBuyingID: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {
    isShowTeamBuyingOrder () {
      return this.$route.name == 'order-list-of-teambuying'
    },
    dataList () {
      var list = this.$store.state.order.list
      if (this.$route.name == 'order-list') list = list.filter(o => !o.TeamBuyingID)
      if (this.$route.name == 'order-list-of-teambuying') list = list.filter(o => o.TeamBuyingID)
      return list
    },
    routeQuery () {
      let query = {
        frompage: this.currentPage
      }
      if (this.filteringStatus) query.filteringStatus = this.filteringStatus
      if (this.keyword) query.keyword = this.keyword
      if (this.filteringDateRange) query.filteringDateRange = JSON.stringify(this.filteringDateRange)
      // 團購
      if (this.isShowTeamBuyingOrder) {
        query.isTeamBuying = 1
        if (this.filteringTeamBuyingID) query.filteringTeamBuyingID = this.filteringTeamBuyingID
      }
      return query
    },
    // 部落客檢視
    isBloggerView () {
      return this.$store.state.admin.AdminLevel == 10
    },
    coupons () {
      return this.$store.state.coupon.list.list
    }
  },
  methods: {
    // for base
    setLoading (key, isLoading) {
      this.isLoading = isLoading
    },
    onExportExcel () {
      const exportExcel = () => {
        try {
          let datas = this.searchedObjs
          let result = ExcelGenerator.generate(this, datas, this.coupons)

          var fileName = window.prompt(
            '請輸入匯出Excel檔之名稱',
            '旬果屋購物官網-訂單匯出'
          )
          if (fileName === null) return // 取消
          if (!fileName) return window.alert('請輸入檔案名稱')
          XLSXSaver.saveAs(result, fileName)
        } catch (e) {
          alert('發生錯誤:' + e)
          window.console.error(`匯出異常`, e)
        }
      }

      // 1. load with details
      var ids = this.searchedObjs.map(o => o.ID)

      this.$services.order.getOrderListWithDetail(this, ids).then(res => {
        var orders = res.data.result
        for (let order of orders) {
          let idx = this.$store.state.order.list.findIndex(o => o.ID === order.ID)
          if (idx >= 0) this.$set(this.$store.state.order.list, idx, order)
          // filter again
          this.filterObjs()
        }
        // 2. export
        exportExcel()
      }).catch(this.$handleServiceError)
    },
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    setFilterStatus (value) {
      this.filteringStatus = value
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
    },
    onDateRangeChanged () {
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange && !this.filteringTeamBuyingID) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let keyword = this.keyword.toLowerCase()
        if (o.User && o.User.Username && o.User.Username.toLowerCase().includes(keyword)) return true

        if (o.User && o.User.Profile && o.User.Profile.Name && o.User.Profile.Name.toLowerCase().includes(keyword)) return true
        if (o.User && o.User.Profile && o.User.Profile.Email && o.User.Profile.Email.toLowerCase().includes(keyword)) return true
        if (o.BuyerInfo && o.BuyerInfo.Name && o.BuyerInfo.Name.toLowerCase().includes(keyword)) return true
        if (o.BuyerInfo && o.BuyerInfo.Email && o.BuyerInfo.Email.toLowerCase().includes(keyword)) return true

        if (getOrderID(o).includes(keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        if (this.filteringStatus === '未付款') return o.PaymentStatus === '未付款'
        if (this.filteringStatus === '已付款') return o.PaymentStatus === '已付款'
        if (this.filteringStatus === '交易完成') return o.OrderStatus === '已完成'
        return true
      }

      const isObjFitTeamBuying = o => {
        if (!this.isShowTeamBuyingOrder) return true
        if (!this.filteringTeamBuyingID) return true
        return o.TeamBuyingID == this.filteringTeamBuyingID
      }

      let startDate = this.filteringDateRange && moment(this.filteringDateRange[0])
      let endDate = this.filteringDateRange && moment(this.filteringDateRange[1])
      const isObjFitDateRange = o => {
        if (!this.filteringDateRange) return true
        let date = moment(o.CreatedAt)
        return (date.isBefore(endDate) && date.isAfter(startDate)) || date.isSame(startDate, 'date') || date.isSame(endDate, 'date')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u) && isObjFitDateRange(u) && isObjFitTeamBuying(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.TitleTw}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.order.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.order.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.order.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    if (this.isBloggerView) {
      this.filteringTeamBuyingID = this.$route.query.id || -1
    }

    this.currentPage = parseInt(this.$route.query.page) || 1
    if (this.$route.query.filteringStatus) this.filteringStatus = this.$route.query.filteringStatus
    if (this.$route.query.filteringDateRange) this.filteringDateRange = JSON.parse(this.$route.query.filteringDateRange)
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
    if (this.isShowTeamBuyingOrder) {
      if (this.$route.query.filteringTeamBuyingID) this.filteringTeamBuyingID = this.$route.query.filteringTeamBuyingID
    }

    const initTableData = () => {
      this.filterObjs()
      this.onChangePage(this.currentPage)
    }
    this.$services.teamBuying.fetchDatas(this)
    // query...
    this.$services.order.getAll(this).then(res => {
      this.$store.state.order.list = res.data.result
      initTableData()
    }).catch(this.$handleServiceError)

    if (this.$store.state.coupon.list.list.length == 0) {
      this.$services.coupon.getAll(this).then(res => {
        this.$store.state.coupon.list.list = res.data.result
      })
    }
  },
  watch: {
    $route (to, from) {
      this.searchWithoutAlertResult()
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
